import { Injectable } from '@angular/core';
import { StatutDA } from '@shared/services/statut-da';

@Injectable({
    providedIn: 'root',
})
export class AssuranceHelperService {
    static readonly qsEnattenteDeSaisie = new StatutDA(
        'FM',
        'QS_EN_ATTENTE_DE_SAISIE',
        'waiting'
    );
    static readonly qsEnAttenteDeSaisiePCconseiller = new StatutDA(
        'FA',
        'QS_EN_ATTENTE_DE_SAISIE_PC_CONSEILLER',
        'unknown'
    );
    static readonly qsEnAttenteDeSaisiePapier = new StatutDA(
        'FB',
        'QS_EN_ATTENTE_DE_SAISIE_PAPIER',
        'unknown'
    );
    static readonly qsEnAttenteDeSaisieInternet = new StatutDA(
        'FC',
        'QS_EN_ATTENTE_DE_SAISIE_INTERNET',
        'waiting'
    );
    static readonly etudeQuestionnaireSante = new StatutDA(
        'FX',
        'ETUDE_QUESTIONNAIRE_SANTE',
        'waiting'
    );
    static readonly piecesMedicalesEnAttenteRetourClient = new StatutDA(
        'FE',
        'PIECES_MEDICALES_EN_ATTENTE_RETOUR_CLIENT',
        'waiting'
    );
    static readonly accordClientEnAttenteRelance = new StatutDA(
        'FH',
        'ACCORD_CLIENT_EN_ATTENTE_RELANCE',
        'waiting'
    );
    static readonly qsEnCoursEtude = new StatutDA(
        'GA',
        'QS_EN_COURS_D_ETUDE',
        'waiting'
    );
    static readonly dossierCompletEnCoursEtude = new StatutDA(
        'GB',
        'DOSSIER_COMPLET_EN_COURS_D_ETUDE',
        'waiting'
    );
    static readonly dossierAccepteGarantieDecesSeule = new StatutDA(
        'AA',
        'DOSSIER_ACCEPTE_GARANTIE_DECES_SEULE',
        'valid'
    );
    static readonly dossierAccepteAvecRestrictionDeGarantie = new StatutDA(
        'AB',
        'DOSSIER_ACCEPTE_AVEC_RESTRICTION_DE_GARANTIE',
        'valid'
    );
    static readonly dossierAccepteAvecMajorationTarifaire = new StatutDA(
        'KB',
        'DOSSIER_ACCEPTE_AVEC_MAJORATION_TARIFAIRE',
        'valid'
    );
    static readonly dossierRefuseSuiteEtudeMedicale = new StatutDA(
        'MB',
        'DOSSIER_REFUSE_SUITE_ETUDE_MEDICALE',
        'refused'
    );
    static readonly propositionSansSuite = new StatutDA(
        'ER',
        'PROPOSITION_SANS_SUITE',
        'unknown'
    );
    static readonly qsNonConformeEnAttenteRetourClientCourrier = new StatutDA(
        'FD',
        'QS_NON_CONFORME_EN_ATTENTE_RETOUR_CLIENT_COURRIER',
        'refused'
    );
    static readonly piecesMedicalesEnAttenteRetourClientRelance = new StatutDA(
        'FF',
        'PIECES_MEDICALES_EN_ATTENTE_RETOUR_CLIENT_RELANCE',
        'waiting'
    );
    static readonly piecesMedicalesNonRecuesAbandonDemandeAdhesion =
        new StatutDA(
            'IA',
            'PIECES_MEDICALES_NON_RECUES_ABANDON_DEMANDE_ADHESION',
            'refused'
        );
    static readonly accordClientNonRecuAbandonDemandeAdhesion = new StatutDA(
        'FI',
        'ACCORD_CLIENT_NON_RECU_ABANDON_DEMANDE_ADHESION',
        'refused'
    );
    static readonly dossierAccepteAuxConditionsGeneralesContrat = new StatutDA(
        'DB',
        'DOSSIER_ACCEPTE_AUX_CONDITIONS_GENERALES_CONTRAT',
        'valid'
    );
    static readonly h2DossierAccepteAuxConditionsGeneralesContrat =
        new StatutDA(
            'CB',
            'H2_DOSSIER_ACCEPTE_AUX_CONDITIONS_GENERALES_CONTRAT',
            'valid'
        );
    static readonly dossierAccepteAvecMajorationTarifaireAccordClientRecu =
        new StatutDA(
            'SY',
            'DOSSIER_ACCEPTE_AVEC_MAJORATION_TARIFAIRE_ACCORD_CLIENT_RECU',
            'valid'
        );
    static readonly h2DossierAccepteGarantieDecesSeuleAccordClientRecu =
        new StatutDA(
            'CA',
            'H2_DOSSIER_ACCEPTE_GARANTIE_DECES_SEULE_ACCORD_CLIENT_RECU',
            'valid'
        );
    static readonly dossierAccepteGarantieDecesSeuleAvecMajorationTarifaire =
        new StatutDA(
            'LA',
            'DOSSIER_ACCEPTE_GARANTIE_DECES_SEULE_AVEC_MAJORATION_TARIFAIRE',
            'valid'
        );
    static readonly dossierAccepteAvecMajorationTarifaireEtRestrictionGarantie =
        new StatutDA(
            'MA',
            'DOSSIER_ACCEPTE_AVEC_MAJORATION_TARIFAIRE_ET_RESTRICTION_GARANTIE',
            'valid'
        );
    static readonly dossierRefuseSuiteEtudeMedicaleEnCoursEtudeContratSurrisqueN2 =
        new StatutDA(
            'DA',
            'DOSSIER_REFUSE_SUITE_ETUDE_MEDICALE_EN_COURS_ETUDE_CONTRAT_SURRISQUE_N2',
            'refused'
        );
    static readonly dossierRefuseSuiteEtudeMedicaleEnCoursEtudeContratSurrisqueN3 =
        new StatutDA(
            'EA',
            'DOSSIER_REFUSE_SUITE_ETUDE_MEDICALE_EN_COURS_ETUDE_CONTRAT_SURRISQUE_N3',
            'refused'
        );
    static readonly dossierAccepteAuxConditionsGeneralesContratAccordClientRecu =
        new StatutDA(
            'XO',
            'DOSSIER_ACCEPTE_AUX_CONDITIONS_GENERALES_CONTRAT_ACCORD_CLIENT_RECU',
            'valid'
        );
    static readonly dossierAccepteAvecRestrictionDeGarantieAccordClientRecu =
        new StatutDA(
            'XP',
            'DOSSIER_ACCEPTE_AVEC_RESTRICTION_DE_GARANTIE_ACCORD_CLIENT_RECU',
            'valid'
        );
    static readonly dossierAccepteAvecMajorationTarifaireEtRestrictionGarantieAccordClientRecu =
        new StatutDA(
            'XY',
            'DOSSIER_ACCEPTE_AVEC_MAJORATION_TARIFAIRE_ET_RESTRICTION_GARANTIE_ACCORD_CLIENT_RECU',
            'valid'
        );
    static readonly dossierAccepteAuxConditionsGeneralesContratAccordClientEnAttente =
        new StatutDA(
            'AV',
            'DOSSIER_ACCEPTE_AUX_CONDITIONS_GENERALES_CONTRAT_ACCORD_CLIENT_EN_ATTENTE',
            'valid'
        );
    static readonly dossierAccepteAvecRestrictionGarantieAccordClientEnAttente =
        new StatutDA(
            'AS',
            'DOSSIER_ACCEPTE_AVEC_RESTRICTION_GARANTIE_ACCORD_CLIENT_EN_ATTENTE',
            'valid'
        );
    static readonly dossierAccepteAvecMajorationTarifaireAccordClientEnAttente =
        new StatutDA(
            'AU',
            'DOSSIER_ACCEPTE_AVEC_MAJORATION_TARIFAIRE_ACCORD_CLIENT_EN_ATTENTE',
            'valid'
        );
    static readonly h2DossierAccepteAuxConditionsGeneralesContratAccordRecu =
        new StatutDA(
            'CC',
            'H2_DOSSIER_ACCEPTE_AUX_CONDITIONS_GENERALES_CONTRAT_ACCORD_RECU',
            'valid'
        );
    static readonly h2DossierAccepteAvecRestrictionDeGarantieAccordClientRecu =
        new StatutDA(
            'CD',
            'H2_DOSSIER_ACCEPTE_AVEC_RESTRICTION_DE_GARANTIE_ACCORD_CLIENT_RECU',
            'valid'
        );
    static readonly h2DossierAccepteAvecMajorationTarifaireAccordClientRecu =
        new StatutDA(
            'CE',
            'H2_DOSSIER_ACCEPTE_AVEC_MAJORATION_TARIFAIRE_ACCORD_CLIENT_RECU',
            'valid'
        );
    static readonly h2DossierAccepteGarantieDecesSeuleAccordClientEnAttente =
        new StatutDA(
            'MC',
            'H2_DOSSIER_ACCEPTE_GARANTIE_DECES_SEULE_ACCORD_CLIENT_EN_ATTENTE',
            'valid'
        );
    static readonly h2DossierAccepteAuxConditionsGeneralesContratAccordClientEnAttente =
        new StatutDA(
            'MD',
            'H2_DOSSIER_ACCEPTE_AUX_CONDITIONS_GENERALES_CONTRAT_ACCORD_CLIENT_EN_ATTENTE',
            'valid'
        );
    static readonly h2DossierAccepteAvecRestrictionDeGarantieAccordClientEnAttente =
        new StatutDA(
            'MF',
            'H2_DOSSIER_ACCEPTE_AVEC_RESTRICTION_DE_GARANTIE_ACCORD_CLIENT_EN_ATTENTE',
            'valid'
        );
    static readonly h2DossierAccepteAvecMajorationTarifaireAccordClientEnAttente =
        new StatutDA(
            'MG',
            'H2_DOSSIER_ACCEPTE_AVEC_MAJORATION_TARIFAIRE_ACCORD_CLIENT_EN_ATTENTE',
            'valid'
        );
    static readonly h2DossierAccepteGarantieDecesSeuleAvecMajorationTarifaireAccordClientEnAttente =
        new StatutDA(
            'MH',
            'H2_DOSSIER_ACCEPTE_GARANTIE_DECES_SEULE_AVEC_MAJORATION_TARIFAIRE_ACCORD_CLIENT_EN_ATTENTE',
            'valid'
        );
    static readonly h2DossierAccepteAvecMajorationTarifaireEtRestrictionGarantieAccordClientEnAttente =
        new StatutDA(
            'MI',
            'H2_DOSSIER_ACCEPTE_AVEC_MAJORATION_TARIFAIRE_ET_RESTRICTION_GARANTIE_ACCORD_CLIENT_EN_ATTENTE',
            'valid'
        );
    static readonly h2DossierAccepteAvecMajorationTarifaireEtRestrictionGarantieAccordClientRecu =
        new StatutDA(
            'CG',
            'H2_DOSSIER_ACCEPTE_AVEC_MAJORATION_TARIFAIRE_ET_RESTRICTION_GARANTIE_ACCORD_CLIENT_RECU',
            'valid'
        );
    static readonly dossierAccepteAvecMajorationTarifaireEtRestrictionGarantieAccordClientEnAttente =
        new StatutDA(
            'AL',
            'DOSSIER_ACCEPTE_AVEC_MAJORATION_TARIFAIRE_ET_RESTRICTION_GARANTIE_ACCORD_CLIENT_EN_ATTENTE',
            'valid'
        );

    static readonly h2DossierAccepteGarantieDecesSeuleAvecMajorationTarifaireAccordClientRecu =
        new StatutDA(
            'CF',
            'H2_DOSSIER_ACCEPTE_GARANTIE_DECES_SEULE_AVEC_MAJORATION_TARIFAIRE_ACCORD_CLIENT_RECU',
            'valid'
        );

    static readonly dossierTransfere = new StatutDA(
        'TR',
        'DOSSIER_FINALISE',
        'valid'
    );

    static readonly typeDashboardUnknow = 'unknown';
    static readonly typeDashboardValid = 'valid';
    static readonly statutEcretementEligible = 'Eligible';
    static readonly codeProduitContratSurrisque = 'AERA18';

    static listStatutDA: StatutDA[];
    static listStatutDAforSignaturePropo: StatutDA[];
    static listStatutDAforFinalisation: StatutDA[];
    static listStatutDAforFinalisationAfterPropoSignature: StatutDA[];

    /**
     * Retourne la liste exhaustive des statuts DA Pegase / CRCA : code AIA, code ADE et le code type pour le dashboard
     */
    static initListStatutDA(): StatutDA[] {
        return [
            AssuranceHelperService.qsEnattenteDeSaisie,
            AssuranceHelperService.qsEnAttenteDeSaisiePCconseiller,
            AssuranceHelperService.qsEnAttenteDeSaisiePapier,
            AssuranceHelperService.qsEnAttenteDeSaisieInternet,
            AssuranceHelperService.etudeQuestionnaireSante,
            AssuranceHelperService.piecesMedicalesEnAttenteRetourClient,
            AssuranceHelperService.accordClientEnAttenteRelance,
            AssuranceHelperService.qsEnCoursEtude,
            AssuranceHelperService.dossierCompletEnCoursEtude,
            AssuranceHelperService.dossierAccepteGarantieDecesSeule,
            AssuranceHelperService.dossierAccepteAvecRestrictionDeGarantie,
            AssuranceHelperService.dossierAccepteAvecMajorationTarifaire,
            AssuranceHelperService.dossierRefuseSuiteEtudeMedicale,
            AssuranceHelperService.propositionSansSuite,
            AssuranceHelperService.qsNonConformeEnAttenteRetourClientCourrier,
            AssuranceHelperService.piecesMedicalesEnAttenteRetourClientRelance,
            AssuranceHelperService.piecesMedicalesNonRecuesAbandonDemandeAdhesion,
            AssuranceHelperService.accordClientNonRecuAbandonDemandeAdhesion,
            AssuranceHelperService.dossierAccepteAuxConditionsGeneralesContrat,
            AssuranceHelperService.h2DossierAccepteAuxConditionsGeneralesContrat,
            AssuranceHelperService.dossierAccepteAvecMajorationTarifaireAccordClientRecu,
            AssuranceHelperService.h2DossierAccepteGarantieDecesSeuleAccordClientRecu,
            AssuranceHelperService.dossierAccepteGarantieDecesSeuleAvecMajorationTarifaire,
            AssuranceHelperService.dossierAccepteAvecMajorationTarifaireEtRestrictionGarantie,
            AssuranceHelperService.dossierRefuseSuiteEtudeMedicaleEnCoursEtudeContratSurrisqueN2,
            AssuranceHelperService.dossierRefuseSuiteEtudeMedicaleEnCoursEtudeContratSurrisqueN3,
            AssuranceHelperService.dossierAccepteAuxConditionsGeneralesContratAccordClientRecu,
            AssuranceHelperService.dossierAccepteAvecRestrictionDeGarantieAccordClientRecu,
            AssuranceHelperService.dossierAccepteAvecMajorationTarifaireEtRestrictionGarantieAccordClientRecu,
            AssuranceHelperService.dossierAccepteAuxConditionsGeneralesContratAccordClientEnAttente,
            AssuranceHelperService.dossierAccepteAvecRestrictionGarantieAccordClientEnAttente,
            AssuranceHelperService.dossierAccepteAvecMajorationTarifaireAccordClientEnAttente,
            AssuranceHelperService.h2DossierAccepteAuxConditionsGeneralesContratAccordRecu,
            AssuranceHelperService.h2DossierAccepteAvecRestrictionDeGarantieAccordClientRecu,
            AssuranceHelperService.h2DossierAccepteAvecMajorationTarifaireAccordClientRecu,
            AssuranceHelperService.h2DossierAccepteGarantieDecesSeuleAccordClientEnAttente,
            AssuranceHelperService.h2DossierAccepteAuxConditionsGeneralesContratAccordClientEnAttente,
            AssuranceHelperService.h2DossierAccepteAvecRestrictionDeGarantieAccordClientEnAttente,
            AssuranceHelperService.h2DossierAccepteAvecMajorationTarifaireAccordClientEnAttente,
            AssuranceHelperService.h2DossierAccepteGarantieDecesSeuleAvecMajorationTarifaireAccordClientEnAttente,
            AssuranceHelperService.h2DossierAccepteAvecMajorationTarifaireEtRestrictionGarantieAccordClientEnAttente,
            AssuranceHelperService.h2DossierAccepteAvecMajorationTarifaireEtRestrictionGarantieAccordClientRecu,
            AssuranceHelperService.dossierAccepteAvecMajorationTarifaireEtRestrictionGarantieAccordClientEnAttente,
            AssuranceHelperService.h2DossierAccepteGarantieDecesSeuleAvecMajorationTarifaireAccordClientRecu,
            AssuranceHelperService.dossierTransfere,
        ];
    }

    /**
     * Retourne la liste des statuts DA elligibles a la signature electronique de la proposition d assurance (seconde signature EADE)
     */
    static initListStatutDAForSignaturePropo(): StatutDA[] {
        return [
            AssuranceHelperService.h2DossierAccepteAvecMajorationTarifaireAccordClientEnAttente,
            AssuranceHelperService.h2DossierAccepteGarantieDecesSeuleAccordClientEnAttente,
            AssuranceHelperService.h2DossierAccepteAvecRestrictionDeGarantieAccordClientEnAttente,
            AssuranceHelperService.h2DossierAccepteAvecMajorationTarifaireEtRestrictionGarantieAccordClientEnAttente,
            AssuranceHelperService.h2DossierAccepteGarantieDecesSeuleAvecMajorationTarifaireAccordClientEnAttente,
            AssuranceHelperService.accordClientEnAttenteRelance,
            AssuranceHelperService.dossierAccepteAuxConditionsGeneralesContratAccordClientEnAttente,
            AssuranceHelperService.dossierAccepteAvecMajorationTarifaireAccordClientEnAttente,
            AssuranceHelperService.dossierAccepteAvecMajorationTarifaireEtRestrictionGarantieAccordClientEnAttente,
            AssuranceHelperService.dossierAccepteAvecRestrictionGarantieAccordClientEnAttente,
            AssuranceHelperService.h2DossierAccepteAuxConditionsGeneralesContratAccordClientEnAttente,
        ];
    }

    /**
     * Retourne la liste des statuts DA elligibles a une fin de parcours EADE
     */
    static initListStatutDAforFinalisation(): StatutDA[] {
        return [
            AssuranceHelperService.h2DossierAccepteAuxConditionsGeneralesContrat,
            AssuranceHelperService.dossierAccepteGarantieDecesSeule,
            AssuranceHelperService.dossierAccepteAvecRestrictionDeGarantie,
            AssuranceHelperService.dossierAccepteAvecMajorationTarifaire,
            AssuranceHelperService.dossierAccepteAuxConditionsGeneralesContrat,
            AssuranceHelperService.dossierAccepteAvecMajorationTarifaireAccordClientRecu,
            AssuranceHelperService.h2DossierAccepteGarantieDecesSeuleAccordClientRecu,
            AssuranceHelperService.dossierAccepteAvecMajorationTarifaireEtRestrictionGarantie,
            AssuranceHelperService.dossierAccepteAuxConditionsGeneralesContratAccordClientRecu,
            AssuranceHelperService.dossierAccepteAvecRestrictionDeGarantieAccordClientRecu,
            AssuranceHelperService.dossierAccepteAvecMajorationTarifaireEtRestrictionGarantieAccordClientRecu,
            AssuranceHelperService.h2DossierAccepteAuxConditionsGeneralesContratAccordRecu,
            AssuranceHelperService.h2DossierAccepteAvecRestrictionDeGarantieAccordClientRecu,
            AssuranceHelperService.h2DossierAccepteAvecMajorationTarifaireAccordClientRecu,
            AssuranceHelperService.h2DossierAccepteAvecMajorationTarifaireEtRestrictionGarantieAccordClientRecu,
            AssuranceHelperService.dossierAccepteGarantieDecesSeuleAvecMajorationTarifaire,
            AssuranceHelperService.h2DossierAccepteGarantieDecesSeuleAvecMajorationTarifaireAccordClientRecu,
        ];
    }

    /**
     * Retourne la liste des statuts DA elligibles a une fin de parcours EADE après une signature de proposition d'assurance
     */
    static initListStatutDAforFinalisationAfterPropoSignature(): StatutDA[] {
        return [
            AssuranceHelperService.dossierAccepteAvecMajorationTarifaireAccordClientRecu,
            AssuranceHelperService.h2DossierAccepteGarantieDecesSeuleAccordClientRecu,
            AssuranceHelperService.dossierAccepteAvecRestrictionDeGarantieAccordClientRecu,
            AssuranceHelperService.dossierAccepteAvecMajorationTarifaireEtRestrictionGarantieAccordClientRecu,
            AssuranceHelperService.h2DossierAccepteAuxConditionsGeneralesContratAccordRecu,
            AssuranceHelperService.h2DossierAccepteAvecRestrictionDeGarantieAccordClientRecu,
            AssuranceHelperService.h2DossierAccepteAvecMajorationTarifaireAccordClientRecu,
            AssuranceHelperService.h2DossierAccepteAvecMajorationTarifaireEtRestrictionGarantieAccordClientRecu,
            AssuranceHelperService.h2DossierAccepteGarantieDecesSeuleAvecMajorationTarifaireAccordClientRecu,
        ];
    }

    static getListStatutDaPostCreation(): StatutDA[] {
        return [
            AssuranceHelperService.qsEnattenteDeSaisie,
            AssuranceHelperService.qsEnAttenteDeSaisiePCconseiller,
            AssuranceHelperService.qsEnAttenteDeSaisiePapier,
            AssuranceHelperService.qsEnAttenteDeSaisieInternet,
        ];
    }

    /**
     * Retourne l objet StatutDA associe a un code AIA
     *
     * @param codeAia: le code AIA du statutDA souhaite
     */
    static getStatutDAfromCodeAia(codeAia: string): StatutDA {
        if (!AssuranceHelperService.listStatutDA) {
            AssuranceHelperService.listStatutDA =
                AssuranceHelperService.initListStatutDA();
        }

        return AssuranceHelperService.listStatutDA.find(
            (status) => status.codeAia === codeAia
        );
    }

    /**
     * Retourne true si le code AIA statut DA est elligible a une signature electronique de la proposition d assurance
     *
     * @param codeAia
     */
    static isCodeAiaStatutDAForSignaturePropo(codeAia: string): boolean {
        if (!AssuranceHelperService.listStatutDAforSignaturePropo) {
            AssuranceHelperService.listStatutDAforSignaturePropo =
                AssuranceHelperService.initListStatutDAForSignaturePropo();
        }

        const result =
            AssuranceHelperService.listStatutDAforSignaturePropo.find(
                (status) => status.codeAia === codeAia
            );
        return result != null;
    }

    /**
     * Retourne true si le code AIA statut DA est elligible a l'upload des pieces medicales attendues
     *
     * @param codeAia
     */
    static isCodeAiaStatutDAForUploadMedicalDocument(codeAia: string): boolean {
        return (
            codeAia ===
                AssuranceHelperService.piecesMedicalesEnAttenteRetourClient
                    .codeAia ||
            codeAia ===
                AssuranceHelperService
                    .piecesMedicalesEnAttenteRetourClientRelance.codeAia
        );
    }

    /**
     * Retourne true si le code AIA statut DA est elligible a une fin de parcours EADE
     *
     * @param codeAia
     */
    static isCodeAiaStatutDAForFinalisation(codeAia: string): boolean {
        if (!AssuranceHelperService.listStatutDAforFinalisation) {
            AssuranceHelperService.listStatutDAforFinalisation =
                AssuranceHelperService.initListStatutDAforFinalisation();
        }

        const result = AssuranceHelperService.listStatutDAforFinalisation.find(
            (status) => status.codeAia === codeAia
        );
        return result != null;
    }

    /**
     * Retourne true si le code AIA statut DA est elligible a une fin de parcours EADE après signature de proposition
     *
     * @param codeAia
     */
    static isCodeAiaStatutDAForFinalisationAfterPropoSignature(
        codeAia: string
    ): boolean {
        if (
            !AssuranceHelperService.listStatutDAforFinalisationAfterPropoSignature
        ) {
            AssuranceHelperService.listStatutDAforFinalisationAfterPropoSignature =
                AssuranceHelperService.initListStatutDAforFinalisationAfterPropoSignature();
        }

        const result =
            AssuranceHelperService.listStatutDAforFinalisationAfterPropoSignature.find(
                (status) => status.codeAia === codeAia
            );
        return result !== undefined;
    }

    /* gets the right bundle key for surrisque projects which are in analysis*/

    static getAlertContratBundleKeyForSurrisqueInAnalysis(
        currentAssurance: any
    ): string {
        if (AssuranceHelperService.isProjectNotAccepted(currentAssurance)) {
            return AssuranceHelperService.getAlertMessageKey(
                'PROJECT_NOT_ACCEPTED'
            );
        }
        if (
            currentAssurance &&
            [
                AssuranceHelperService
                    .dossierRefuseSuiteEtudeMedicaleEnCoursEtudeContratSurrisqueN3
                    .codeAia,
                AssuranceHelperService
                    .dossierRefuseSuiteEtudeMedicaleEnCoursEtudeContratSurrisqueN2
                    .codeAia,
            ].includes(currentAssurance.statutDA)
        ) {
            return AssuranceHelperService.getAlertMessageKey(
                currentAssurance.statutDA
            );
        }
        return null;
    }

    /* gets the right bundle for projects with alarm status*/

    static getAlertContratBundleKeyForAlarmStatus(
        currentAssurance: any
    ): string {
        const isWaitingClientStatutDAList = [
            AssuranceHelperService
                .h2DossierAccepteAvecMajorationTarifaireEtRestrictionGarantieAccordClientEnAttente
                .codeAia,
            AssuranceHelperService
                .h2DossierAccepteGarantieDecesSeuleAvecMajorationTarifaireAccordClientEnAttente
                .codeAia,
            AssuranceHelperService
                .h2DossierAccepteAvecMajorationTarifaireAccordClientEnAttente
                .codeAia,
            AssuranceHelperService
                .h2DossierAccepteAvecRestrictionDeGarantieAccordClientEnAttente
                .codeAia,
            AssuranceHelperService
                .h2DossierAccepteAuxConditionsGeneralesContratAccordClientEnAttente
                .codeAia,
            AssuranceHelperService
                .h2DossierAccepteGarantieDecesSeuleAccordClientEnAttente
                .codeAia,
            AssuranceHelperService
                .dossierAccepteAvecRestrictionGarantieAccordClientEnAttente
                .codeAia,
            AssuranceHelperService
                .dossierAccepteAvecMajorationTarifaireAccordClientEnAttente
                .codeAia,
            AssuranceHelperService
                .dossierAccepteAuxConditionsGeneralesContratAccordClientEnAttente
                .codeAia,
            AssuranceHelperService
                .dossierAccepteAvecMajorationTarifaireEtRestrictionGarantieAccordClientEnAttente
                .codeAia,
            AssuranceHelperService.accordClientEnAttenteRelance.codeAia,
        ];
        const isClientAcceptedStatusDAList = [
            AssuranceHelperService
                .h2DossierAccepteAvecMajorationTarifaireEtRestrictionGarantieAccordClientRecu
                .codeAia,
            AssuranceHelperService
                .h2DossierAccepteGarantieDecesSeuleAvecMajorationTarifaireAccordClientRecu
                .codeAia,
            AssuranceHelperService
                .h2DossierAccepteAvecMajorationTarifaireAccordClientRecu
                .codeAia,
            AssuranceHelperService
                .h2DossierAccepteAvecRestrictionDeGarantieAccordClientRecu
                .codeAia,
            AssuranceHelperService
                .h2DossierAccepteAuxConditionsGeneralesContratAccordRecu
                .codeAia,
            AssuranceHelperService.h2DossierAccepteAuxConditionsGeneralesContrat
                .codeAia,
            AssuranceHelperService
                .h2DossierAccepteGarantieDecesSeuleAccordClientRecu.codeAia,
            AssuranceHelperService
                .dossierAccepteAvecMajorationTarifaireEtRestrictionGarantieAccordClientRecu
                .codeAia,
            AssuranceHelperService
                .dossierAccepteAvecMajorationTarifaireAccordClientRecu.codeAia,
            AssuranceHelperService
                .dossierAccepteAvecRestrictionDeGarantieAccordClientRecu
                .codeAia,
            AssuranceHelperService
                .dossierAccepteAuxConditionsGeneralesContratAccordClientRecu
                .codeAia,
        ];

        if (currentAssurance) {
            const statutDA = currentAssurance.statutDA;
            if (
                currentAssurance.offreSelectionnee.codeProduit === 'AERA18' &&
                isClientAcceptedStatusDAList.includes(statutDA)
            ) {
                return AssuranceHelperService.getAlertMessageKey(
                    'CLIENT_ACCEPTED'
                );
            }
            if (
                currentAssurance.offreSelectionnee.codeProduit === 'AERA18' &&
                isWaitingClientStatutDAList.includes(statutDA)
            ) {
                return AssuranceHelperService.getAlertMessageKey(
                    'WAITING_CLIENT'
                );
            }
        }

        return null;
    }

    /* gets the right bundle key for alert surrisque message */

    static getAlertContratBundleKey(currentAssurance: any): string {
        return (
            AssuranceHelperService.getAlertContratBundleKeyForSurrisqueInAnalysis(
                currentAssurance
            ) ||
            AssuranceHelperService.getAlertContratBundleKeyForAlarmStatus(
                currentAssurance
            )
        );
    }

    /* returns true if the assurance project is not accepted */

    static isProjectNotAccepted(currentAssurance: any): boolean {
        const projectNotAcceptedStatutDAList = [
            AssuranceHelperService
                .dossierRefuseSuiteEtudeMedicaleEnCoursEtudeContratSurrisqueN3
                .codeAia,
            AssuranceHelperService
                .piecesMedicalesNonRecuesAbandonDemandeAdhesion.codeAia,
            AssuranceHelperService.accordClientNonRecuAbandonDemandeAdhesion
                .codeAia,
        ];
        return (
            currentAssurance &&
            projectNotAcceptedStatutDAList.includes(currentAssurance.statutDA)
        );
    }

    /* return true if the initial proposition is refused in order to be replaced
       with a surrisque proposition (AERA18) */

    static isStudySurrisqueLevel2(currentAssurance: any) {
        return (
            currentAssurance &&
            currentAssurance.statutDA ===
                AssuranceHelperService
                    .dossierRefuseSuiteEtudeMedicaleEnCoursEtudeContratSurrisqueN2
                    .codeAia &&
            ['IMMO18', 'CONS18', 'PROA18'].includes(
                currentAssurance.offreSelectionnee.codeProduit
            )
        );
    }

    private static getAlertMessageKey(suffix: string): string {
        return `dashboard.project.surrisque.${suffix}`;
    }
}
